/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Extend from './extend.mdx';
import InjectGlobal from './inject-global.mdx';
import InnerRef from './inner-ref.mdx';
import WithComponent from './with-component.mdx';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "以前的 API(Previous APIs)"
    }), "\n", _jsx(_components.p, {
      children: "¥Previous APIs"
    }), "\n", _jsx(Extend, {}), "\n", _jsx(InjectGlobal, {}), "\n", _jsx(InnerRef, {}), "\n", _jsx(WithComponent, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
